module.exports = __webpack_public_path__ + "img/Color-swatch.cc04cbac.svg";